import { Box, Stack } from '@mui/material'
import { styled } from '@mui/styles'

export const HeaderBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(3, 4, 3, 5),
}))

export const HeaderNav = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(4),
}))

export const AppWrapper = styled(Stack)(() => ({
  position: 'relative',
  display: 'flex',
  flex: 1,
  gap: '16px'
}))
